import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Form, Modal } from 'react-bootstrap';
import { canAccessModuleAccessibility } from '../../utils/roleConstants';
import { moduleAccessibilityService as service } from '../../_services/moduleAccessibility.service';
import { CompanyModulePermissions } from './CompanyModulePermissions';

function ModuleAccessibilityContent() {
    const [companies, setCompanies] = useState(null);
    const [company, setCompany] = useState('');
    const [pendingCompany, setPendingCompany] = useState(null);
    const [dirty, setDirty] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let disposed = false;
        setError('');
        const result = service.companies();

        if (result.data !== null) setCompanies(result.data);

        result.revalidate.then(value => { if (!disposed) setCompanies(value); })
            .catch(err => { if (!disposed) { setCompanies(null); setError(err.message); } });

        return () => { disposed = true; };
    }, [attempt]);

    useEffect(() => {
        if (!dirty && !busy) return;

        const beforeUnload = event => { event.preventDefault(); event.returnValue = ''; };
        window.addEventListener('beforeunload', beforeUnload);

        return () => window.removeEventListener('beforeunload', beforeUnload);
    }, [dirty, busy]);

    return (
        <div className="container-fluid py-4">
            <h2>Module Accessibility</h2>
            <p className="text-muted">Select a company and choose the modules it can access. Click Save changes to apply your selections.</p>
            <Card><Card.Body>
                {error && <Alert variant="danger">{error} <Button variant="outline-danger" size="sm" onClick={() => setAttempt(value => value + 1)}>Retry</Button></Alert>}
                <Form.Group controlId="module-access-company" className="mb-4" style={{ maxWidth: 420 }}>
                    <Form.Label>Company</Form.Label>
                    <Form.Select value={company} disabled={companies === null || busy} onChange={event => {
                        if (dirty) setPendingCompany(event.target.value);
                        else setCompany(event.target.value);
                    }}>
                        <option value="">{companies === null ? 'Loading companies…' : 'Select a company'}</option>
                        {(companies || []).map(item => <option key={item.id} value={item.id}>{item.companyName}</option>)}
                    </Form.Select>
                </Form.Group>
                {company ? <CompanyModulePermissions key={company} company={company} onDirtyChange={setDirty} onBusyChange={setBusy} /> :
                 <p className="text-muted mb-0">Select a company to manage its module permissions.</p>}
            </Card.Body></Card>
            <p className="text-muted small mt-3">Users may need to sign out and sign in again for updated module access to appear.</p>
            <Modal show={pendingCompany !== null} onHide={() => setPendingCompany(null)} aria-labelledby="module-discard-title">
                <Modal.Header closeButton><Modal.Title id="module-discard-title">Discard unsaved changes?</Modal.Title></Modal.Header>
                <Modal.Body>Your module selections have not been saved. Switching companies will discard them.</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setPendingCompany(null)}>Keep editing</Button>
                    <Button variant="danger" onClick={() => { setDirty(false); setCompany(pendingCompany); setPendingCompany(null); }}>Discard and switch</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export function ModuleAccessibility() {
    let user;

    try { user = JSON.parse(localStorage.getItem('user')); } catch { user = null; }

    if (!canAccessModuleAccessibility(user)) return <Alert variant="danger" className="m-4"><h4>Access denied</h4>Only user 1 (test) can manage module accessibility.</Alert>;
    
    return <ModuleAccessibilityContent />;
}
